:host {
    @apply block;
}
  
.bg-transparent-white {
    background-color: rgba(255, 255, 255, 0.8);
}